import React from "react";
import {useSelector} from "react-redux";
import {Edit} from "@mui/icons-material";
import {Box, MenuItem, Typography} from "@mui/material";
import {StyledIconBox, StyledLeagueSelector} from "./styles";
import {useLocation} from "react-router-dom";

const SMPTitleBar = ({
                         name,
                         handleToggle,
                         leagueId,
                         handleLeagueId,
                         toggleUpdateSMP,
                     }) => {
    const smpListSelector = useSelector((state) => state.getSmpListReducer);

    const {role} = useSelector((state) => state.userDetailsReducer);

    const {pathname} = useLocation();

    return (
        <Box
            sx={{display: "flex", justifyContent: "space-between"}}
            flexDirection={{xs: "column", md: "row"}}
        >
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 700,
                    fontSize: {md: "20px", xxl: "40px"},
                }}
                color="initial"
            >
                {name}
            </Typography>

            <Box sx={{display: "flex", marginRight: "0 !important"}}>
                {pathname.includes("scorecard") || toggleUpdateSMP ? null : (
                    <StyledLeagueSelector
                        fullWidth
                        value={leagueId}
                        disableUnderline
                        variant="standard"
                        onChange={(e) => handleLeagueId(e.target.value)}
                    >
                        {!smpListSelector.loading &&
                            smpListSelector.status?.leagues != undefined &&
                            smpListSelector.status.leagues.map((league) => {
                                return <MenuItem value={league._id}>{league.name}</MenuItem>;
                            })}
                    </StyledLeagueSelector>
                )}

                {(role === "admin" || role === "super") && (
                    <StyledIconBox onClick={handleToggle}>
                        <Edit sx={{color: "white"}}/>
                    </StyledIconBox>
                )}
            </Box>
        </Box>
    );
};

export default SMPTitleBar;
